module.exports = __webpack_public_path__ + "static/img/yhbh.43d47544.png";